/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChessKing = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M13 3.294A4.339 4.339 0 0 1 14.571 3C17.037 3 19 5.034 19 7.5c0 .921-.274 1.783-.746 2.5H20v2h-4.4c.67 1.898 1.782 3.3 2.707 4.016A3 3 0 0 1 21 19v3H3v-3a3 3 0 0 1 2.818-2.994c.897-.716 1.963-2.112 2.606-4.006H4v-2h1.746A4.537 4.537 0 0 1 5 7.5C5 5.034 6.964 3 9.429 3c.554 0 1.084.105 1.571.294V2h2zM6 18a1 1 0 0 0-1 1v1h14v-1a1 1 0 0 0-1-1zm4.516-6c-.445 1.578-1.155 2.939-1.954 4h6.955a12.092 12.092 0 0 1-2.016-4zm4.055-7c-.716 0-1.364.32-1.814.843L12 6.72l-.757-.877A2.389 2.389 0 0 0 9.43 5C8.107 5 7 6.1 7 7.5S8.107 10 9.429 10h5.142C15.893 10 17 8.9 17 7.5S15.893 5 14.571 5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChessKing as ChessKing };
